import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getPaletteAsRawColors } from 'owa-theme';
import { ITheme } from 'office-ui-fabric-react/lib/Styling';
import { themeFromColorScheme } from 'owa-color-utils/lib/colorUtils';

export default function(colorScheme: ColorScheme): ITheme {
    const calendarTheme = themeFromColorScheme(colorScheme);
    const neutralSecondary = getPaletteAsRawColors().neutralSecondary;
    const neutralDark = getPaletteAsRawColors().neutralDark;
    return {
        ...calendarTheme,
        semanticColors: {
            ...calendarTheme.semanticColors,
            smallInputBorder: neutralSecondary,
            inputBorderHovered: neutralDark,
        },
    };
}
